exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-management-confirmation-modal .modal-card-head[data-v-7d228b2d] {\n  border-radius: 0px;\n  background-color: #FC6859;\n  padding: 1rem;\n  font-size: 1.2rem;\n}\n.user-management-confirmation-modal .modal-card-head .modal-card-title[data-v-7d228b2d] {\n  color: white;\n  border-radius: 0px;\n}", ""]);

// exports
